// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { TracingAreaRoutes } from '@backoffice-frontend/tracing-api'
import { ClockCounterIcon } from '@moia-dev/pace-icons'

export const TracingAreaNavigationIcon = ClockCounterIcon

export const TracingAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={TracingAreaRoutes.route}
      Icon={ClockCounterIcon}
    />
  )
}
